import {useTranslation} from 'react-i18next'
import useWindowDimensions from '@hooks/useWindowDimensions.ts'
import {useState} from 'react'
import {ROUTE_HOME, UserRoleE} from '@/utilities/constants'
import {
    StyledContactUs,
    StyledContactUsSection,
    StyledList,
    StyledLogo,
    StyledMainWrapper,
    StyledRoot,
    StyledUserInfo,
    StyledChevronButton
} from './style'
import LogoIcon from '@assets/images/LOGO_ARYA_SUNPRO.png'
import {getCorrectMenuItemsList} from './menuItemsList'
import {ButtonNavLink} from '@/components/ui/button-nav-link/ButtonNavLink'
import {useNavigate} from 'react-router-dom'
import {LogoutModal} from '@/features/auth/components/logout-modal/LogoutModal'
import {EditProfileModal} from '@/features/profile/components/edit-profile-modal/EditProfileModal'
import {LogOut01Icon, ChevronLeftIcon, ProfileIcon, ContactUsIcon} from '@/assets/icons/icons'
import {useMe} from '@/features/auth/queries/useMe'
import {Divider} from '@/components/ui/divider/Divider'
import {ContactUsModal} from '@/features/contact-us/components/contact-us-modal/ContactUsModal'

export const NavBar = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const {height} = useWindowDimensions()
    const {data: user} = useMe()
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)
    const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false)
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false)
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(true)

    const menuList = getCorrectMenuItemsList(user?.company?.type)

    const menuBottomList = () => {
        switch (user?.company?.type) {
            case UserRoleE.SUPPLIER:
                return menuList.bottomMenuItems
            case UserRoleE.INSTALLER:
                return menuList.bottomMenuItemsInstaller
            case UserRoleE.RESELLER:
                return menuList.bottomMenuItemsReseller
            default:
                return []
        }
    }

    return (
        <StyledRoot $vh={height} $isExpanded={isSidebarExpanded}>
            <StyledMainWrapper>
                <div>
                    <StyledChevronButton
                        onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
                        $isExpanded={isSidebarExpanded}
                    >
                        <ChevronLeftIcon />
                    </StyledChevronButton>
                    <StyledLogo>
                        <img src={LogoIcon} alt={'arya-icon'} onClick={() => navigate(ROUTE_HOME)} />
                    </StyledLogo>

                    <StyledList>
                        {menuList.topMenuItems.map(item => {
                            return (
                                item.show && (
                                    <ButtonNavLink to={item.to} key={item.id} isExpanded={isSidebarExpanded}>
                                        {item.icon}
                                        <p>{isSidebarExpanded ? t(item.title) : null}</p>
                                    </ButtonNavLink>
                                )
                            )
                        })}
                    </StyledList>
                </div>

                <div>
                    <StyledList>
                        {menuBottomList().map(item => {
                            return (
                                <ButtonNavLink to={item.to} key={item.id} isExpanded={isSidebarExpanded}>
                                    {item.icon}
                                    <p>{isSidebarExpanded ? t(item.title) : null}</p>
                                </ButtonNavLink>
                            )
                        })}
                    </StyledList>
                    <StyledUserInfo $isExpanded={isSidebarExpanded}>
                        <div onClick={() => setIsEditProfileModalOpen(true)}>
                            {isSidebarExpanded ? (
                                <>
                                    <p>{`${user?.firstName} ${user?.lastName}`}</p>
                                    <span>{user?.email}</span>
                                </>
                            ) : (
                                <ProfileIcon />
                            )}
                        </div>
                        <LogOut01Icon onClick={() => setIsLogoutModalOpen(true)} />
                    </StyledUserInfo>
                    <StyledContactUsSection direction="column" gap={4} align="center">
                        <Divider direction="horizontal" />
                        <StyledContactUs onClick={() => setIsContactUsModalOpen(true)}>
                            {isSidebarExpanded ? (
                                <p style={{cursor: 'pointer', textDecoration: 'underline'}}>
                                    {t('commons:contact_us')}
                                </p>
                            ) : (
                                <ContactUsIcon />
                            )}
                        </StyledContactUs>
                    </StyledContactUsSection>
                </div>
            </StyledMainWrapper>
            {isLogoutModalOpen && <LogoutModal onClose={() => setIsLogoutModalOpen(false)} />}
            {isEditProfileModalOpen && <EditProfileModal onClose={() => setIsEditProfileModalOpen(false)} />}
            {isContactUsModalOpen && <ContactUsModal onClose={() => setIsContactUsModalOpen(false)} />}
        </StyledRoot>
    )
}
